var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "audio-container" }, [_vm.audioOnlyLogo ? _c('svg-icon', { staticClass: "audio-logo", attrs: { "icon-class": "music" } }) : _vm.audioControls ? _c('audio-controller', { attrs: { "url": _vm.url } }) : _c('div', { staticClass: "audio", style: _vm.audioStyle, on: { "mouseenter": _vm.handleMouseEnter, "mouseleave": _vm.handleMouseLeave } }, [_vm.url ? _c('aplayer', _vm._b({ ref: "audioPlayer", on: { "canplay": function canplay($event) {
        return _vm.$emit('can-play');
      }, "play": function play($event) {
        return _vm.$emit('play');
      }, "pause": function pause($event) {
        return _vm.$emit('pause');
      } } }, 'aplayer', _vm.playerAttrs, false)) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm.fileMeta ? _c('file-meta', _vm._b({ attrs: { "customStyle": _vm.fileMetaStyle } }, 'file-meta', _vm.fileMeta, false)) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };